import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateUserNotificationSettingsRequest: ["notificationType", "status"],
  updateUserNotificationSettingsSuccess: ["payload"],
  updateUserNotificationSettingsFailure: null,
});

export const UpdateUserNotificationSettingsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  notificationType: null,
  status: null,
  fetching: null,
  success: null,
  error: null,
  payload: null,
});

export const UpdateUserNotificationSettingsSelectors = {
  getData: (state: any) => state.updateUserNotificationSettings.data,
  isFetching: (state: any) => state.updateUserNotificationSettings.fetching,
  isSuccess: (state: any) => state.updateUserNotificationSettings.success,
  hasError: (state: any) => state.updateUserNotificationSettings.error,
};

export const request = (state: any, { notificationType, status }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    notificationType,
    status,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { payload } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    payload,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST]: request,
  [Types.UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS]: success,
  [Types.UPDATE_USER_NOTIFICATION_SETTINGS_FAILURE]: failure,
});
